import { Skeleton } from "@/shared/ui";

const COLUMN_WIDTHS = [40, 90, 200, 160, 90, 90, 90];

export default function ProjectTableSkeleton() {
  return (
    <div className="border-2 surface-container-stroke rounded-[20px] overflow-hidden">
      <div className="flex gap-0 surface-tertiary-fill border-b surface-container-stroke">
        {COLUMN_WIDTHS.map(function renderHeadCell(w, i) {
          return (
            <div key={i} className={i === 2 ? "py-3 px-4 flex-1" : "py-3 px-4 flex-shrink-0"} style={i === 2 ? undefined : { width: w }}>
              <Skeleton height={14} />
            </div>
          );
        })}
      </div>
      {Array.from({ length: 10 }).map(function renderRow(_, rowIndex) {
        return (
          <div key={rowIndex} className="flex gap-0 border-b surface-container-stroke last:border-none">
            {COLUMN_WIDTHS.map(function renderCell(w, colIndex) {
              return (
                <div
                  key={colIndex}
                  className={colIndex === 2 ? "py-3 px-4 flex-1" : "py-3 px-4 flex-shrink-0"}
                  style={colIndex === 2 ? undefined : { width: w }}>
                  {(colIndex === 0 || colIndex === 2 || colIndex >= 4) && <Skeleton height={14} />}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
